module.exports = __webpack_public_path__ + "media/images/upload-bde0ba2b83b8c89e694fdc0989ea1deb.png";